locationsAreEqual